module.exports = __webpack_public_path__ + "assets/img/moren_head.91a56197.png";